'use client';
import { objectEntries } from '@s7/utils';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupported_iterable_to_array(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) {
                return {
                    done: true
                };
            }
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function parseHotkey(hotkey) {
    var keys = hotkey.toLowerCase().split("+").map(function(part) {
        return part.trim();
    });
    var modifiers = {
        alt: keys.includes("alt"),
        ctrl: keys.includes("ctrl"),
        meta: keys.includes("meta"),
        mod: keys.includes("mod"),
        shift: keys.includes("shift")
    };
    var reservedKeys = [
        "alt",
        "ctrl",
        "meta",
        "shift",
        "mod"
    ];
    var freeKey = keys.find(function(key) {
        return !reservedKeys.includes(key);
    });
    return _extends({}, modifiers, {
        key: freeKey
    });
}
function isExactHotkey(hotkey, event) {
    var alt = hotkey.alt, ctrl = hotkey.ctrl, meta = hotkey.meta, mod = hotkey.mod, shift = hotkey.shift, key = hotkey.key;
    var altKey = event.altKey, ctrlKey = event.ctrlKey, metaKey = event.metaKey, shiftKey = event.shiftKey, pressedKey = event.key;
    if (alt !== altKey) {
        return false;
    }
    if (mod) {
        if (!ctrlKey && !metaKey) {
            return false;
        }
    } else {
        if (ctrl !== ctrlKey) {
            return false;
        }
        if (meta !== metaKey) {
            return false;
        }
    }
    if (shift !== shiftKey) {
        return false;
    }
    if (key && (pressedKey.toLowerCase() === key.toLowerCase() || event.code.replace("Key", "").toLowerCase() === key.toLowerCase())) {
        return true;
    }
    return false;
}
function getHotkeyMatcher(hotkey) {
    return function(event) {
        return isExactHotkey(parseHotkey(hotkey), event);
    };
}
function getHotkeyHandler(hotkeys) {
    return function(event) {
        var _event = "nativeEvent" in event ? event.nativeEvent : event;
        for(var _iterator = _create_for_of_iterator_helper_loose(objectEntries(hotkeys)), _step; !(_step = _iterator()).done;){
            var _step_value = _step.value, hotkey = _step_value[0], handler = _step_value[1];
            if (getHotkeyMatcher(hotkey)(_event)) {
                handler(_event);
            }
        }
    };
}

export { getHotkeyHandler, getHotkeyMatcher, parseHotkey };
